module.exports = "<!-- <div class=\"sidebar-header\"></div> -->\n"